<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')" @onTitleClick="$router.push({ path: '/accounts' })">

        <template #left-options>
          <accountSidebar switch_tab="activities" :account="account"></accountSidebar>
        </template>


        <div class="options">
          <widgetSearch v-if="false" class="search-account" placeholder="Type in to Search..." icon="right"
            v-model="search_input">
          </widgetSearch>

          <div v-if="false" class="h-spacer"></div>

          <widgetDropdown v-if="false" v-model="sort_input_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              <span v-if="selected_filter == 'all'">All Notes</span>
              <span v-if="selected_filter == 'today'">Today</span>
              <span v-if="selected_filter == 'last_week'">Last week</span>
              <span v-if="selected_filter == 'last_month'">Last month</span>
              <span v-if="selected_filter == 'last_year'">Last year</span>
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in view_filter" :key="index"
                @click="filterNotes(item.value)">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div v-if="false" class="v-line-divider" style="height: 40px"></div>

          <widgetButton v-if="false" @click="addNewNote()" :loading="false" style="width: 120px" class="btn-primary">
            Add New +
          </widgetButton>
          <div v-if="false" class="v-line-divider" style="height: 20px"></div>
          <dropdown-menu v-if="false" class="table-menu">
            <ul>
              <li>
                <a @click.prevent="openUploadNotesModal()">Upload Notes</a>
              </li>
            </ul>
          </dropdown-menu>
          <div v-if="false" class="v-line-divider" style="height: 40px"></div>
          <widgetProfile :title="account.name" subtitle="" file_name="" path="" @click="
            $router.push({ path: '/accounts' })
            " titleDirection="left"></widgetProfile>
        </div>
      </WidgetToolbar>
    </div>
    <div class="notes-filter">
      <notesFilter @add="addNewNote()" @filter-change="filterNotes"></notesFilter>
    </div>
    <div class="page-body">
      <div class="notes-wrapper">
        <div class="notes-widget">
          <multipane class="custom-resizer" layout="vertical">


            <div v-if="!isLoading && notes_data.length > 0" class="notes-list">
              <div class="notes-body">
                <template v-for="(item, index) in notes_data">

                  <div class="notes-item system-activity" v-if="item.type == 'notes'" :key="`system-${index}`"
                    @click="selectNote(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ item.created_by }} {{ item.action }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="notes-item task-activity" v-else-if="item.type == 'tasks'" :key="`task-${index}`"
                    @click="selectTask(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ item.created_by }} {{ item.action }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="notes-item lead-activity" v-else-if="item.type == 'leads'" :key="`lead-${index}`"
                    @click="selectLead(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ item.created_by }} {{ item.action }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="notes-item email-activity" v-else-if="item.type == 'email'" :key="`email-${index}`"
                    @click="selectEmail(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ item.created_by }} {{ item.action }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="notes-item calendar-activity" v-else-if="item.type == 'calendar'"
                    :key="`calendar-${index}`" @click="selectCalendar(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ getCalendarEventTitle(item) }} from {{ item.from }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="notes-item" v-else-if="item.title || item.content" :key="`note-${index}`"
                    @click="selectNote(item)">
                    <div class="notes-item-col">
                      <div class="note-content">
                        {{ item.title || "Untitled" }}
                      </div>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-time">
                        <template v-if="moment(item.created_at).isSame(moment(), 'day')">
                          {{ moment(item.created_at).format('HH:mm') }}
                        </template>
                        <template v-else-if="moment(item.created_at).isSame(moment().subtract(1, 'day'), 'day')">
                          Yesterday
                        </template>
                        <template v-else>
                          {{ moment(item.created_at).fromNow() }}
                        </template>
                      </span>
                    </div>
                    <div class="notes-item-col">
                      <span class="note-contact" v-if="item.contacts && item.contacts.length > 0">
                        <widgetProfile :title="item.contacts[0].first_name + ' ' + item.contacts[0].last_name"
                          :size="18" :text_size="6" :subtitle="''" :file_name="null"
                          :path="$fullUrl('images/profiles/')">
                        </widgetProfile>
                      </span>
                    </div>
                  </div>
                </template>

              </div>
            </div>


            <div v-if="isLoading" class="notes-list">
              <div class="loading-widget">
                <loading :height="40" :width="40" :active="true" color="#000" :is-full-page="false" />
              </div>
            </div>


            <div class="notes-list" v-if="notes_data.length == 0">
              <div class="notes-not-found-widget">
                <widgetNotFoundWidget title="No Notes Found"
                  content="Notes are not available, click Add New button for new note" btntext="Add New"
                  @click="addNewNote()">
                  <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
                </widgetNotFoundWidget>
              </div>
            </div>


            <multipane-resizer></multipane-resizer>
            <div class="note-details" v-if="selected_note" :style="{ flexGrow: 1 }">
              <ManipulateNoteWidget v-if="isManipulatingNotes" @close="onCloseAddNoteWidget" @added="onAddNoteAdded"
                @updated="getAllNotes" :note_item="selected_note" :account="account">
              </ManipulateNoteWidget>
              <NotePreviewWidget :note_item="selected_note" v-if="!isManipulatingNotes && selected_note"
                @editNote="onEditNote" @noteContentChange="noteContentChange" @noteFileUploaded="noteFileUploaded"
                @deleteNote="onDeleteNote">
              </NotePreviewWidget>
              <div class="empty-widget" v-if="!isManipulatingNotes && !selected_note">
                <widgetNotFoundWidget title="No Notes Selected" content="Select a note from the list to view details">
                  <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
                </widgetNotFoundWidget>
              </div>
            </div>
            <div class="note-details email-details" v-show="selected_email" :style="{ flexGrow: 1 }">
              <emailPreviewWidget :email_item="selected_email"></emailPreviewWidget>
            </div>
            <div class="note-details task-details" v-show="selected_task" :style="{ flexGrow: 1 }">
              <TaskPreviewWidget :task_item="selected_task"></TaskPreviewWidget>
            </div>
            <div class="note-details lead-details" v-show="selected_lead" :style="{ flexGrow: 1 }">
              <LeadPreviewWidget :lead_item="selected_lead"></LeadPreviewWidget>
            </div>
            <div class="note-details calendar-details" v-show="selected_calendar" :style="{ flexGrow: 1 }">
              <CalendarPreviewWidget :calendar_item="selected_calendar"></CalendarPreviewWidget>
            </div>
            <div class="note-details empty-widget"
              v-if="!selected_note && !selected_email && !selected_task && !selected_lead && !selected_calendar">
              <widgetNotFoundWidget title="No Items Selected"
                content="Select a note, email, task, lead, or calendar event from the list to view details">
                <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
              </widgetNotFoundWidget>
            </div>
          </multipane>
        </div>
      </div>
    </div>

    <uploadNotesModal v-if="showuploadNotesModal" @success="onUploadSucess" @close="showuploadNotesModal = false">
    </uploadNotesModal>

  </div>
</template>

<script>
import { eventBus } from "@/main";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import uploadNotesModal from "@/views/Accounts/AccountsView/components/upload_notes_modal.vue";
import notesFilter from "@/views/Accounts/AccountsView/components/notes_filter.vue";
import NotePreviewWidget from "@/views/Accounts/AccountsView/components/note_preview_widget.vue";
import ManipulateNoteWidget from "@/views/Accounts/AccountsView/components/manipulate_note_widget.vue";
import emailPreviewWidget from "@/views/Accounts/AccountsView/components/email_preview_widget.vue";
import TaskPreviewWidget from "@/views/Accounts/AccountsView/components/task_preview_widget.vue";
import LeadPreviewWidget from "@/views/Accounts/AccountsView/components/lead_preview_widget.vue";
import CalendarPreviewWidget from "@/views/Accounts/AccountsView/components/calendar_preview_widget.vue";
export default {
  name: "",
  components: {
    accountSidebar,
    uploadNotesModal,
    notesFilter,
    NotePreviewWidget,
    ManipulateNoteWidget,
    emailPreviewWidget,
    TaskPreviewWidget,
    LeadPreviewWidget,
    CalendarPreviewWidget,
  },
  data: () => {
    return {
      showuploadNotesModal: false,
      sort_input_filter: false,
      account: {},
      search_input: "",
      selected_filter: "all",
      selected_note: null,
      note_colors: ["light_yellow", "light_red", "light_green", "light_grey"],
      notes_data: [],
      isLoading: false,
      show_selected_activities_options: false,
      form: {
        id: null,
        account_id: null,
        content: "",
        color: "light_yellow",
        owner: null,
      },
      submit_note_loading: false,
      show_add_notes: false,
      form_filter: {
        dateRange: {
          startDate: null,
          endDate: null
        },
        quickFilter: null,
        noteTypes: [],
        selectedPeople: [],
        account_id: null,
      },
      isManipulatingNotes: false,
      selected_email: null,
      selected_task: null,
      selected_lead: null,
      selected_calendar: null,
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  computed: {},
  watch: {
  },
  methods: {
    noteContentChange(content) {
      let vm = this;
      vm.$store.dispatch("NOTES_UPDATE_CONTENT", {
        id: vm.selected_note.id,
        content: content,
      })
        .then((responce) => {
          //vm.getAllNotes();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    noteFileUploaded(file) {
      let vm = this;
      vm.getAllNotes();

    },
    onEditNote(note) {
      let vm = this;
      console.log(note);
      vm.selected_note = note;
      vm.isManipulatingNotes = true;
    },
    onAddNoteAdded() {
      let vm = this;
      vm.isManipulatingNotes = false;
      vm.selected_note = null;
      vm.getAllNotes();
    },
    filterNotes(filter) {
      const vm = this;
      vm.form_filter = { ...filter, account_id: vm.$route.params.id, };
      vm.getAllNotes();
    },
    onUploadSucess() {
      let vm = this;
      vm.showuploadNotesModal = false;
      vm.getAllNotes();
    },
    openUploadNotesModal() {
      let vm = this;
      vm.showuploadNotesModal = true;
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    selectNote(item) {
      let vm = this;
      vm.selected_email = null;
      vm.selected_task = null;
      vm.selected_lead = null;
      vm.selected_calendar = null;
      if (item.title || item.content) {
        vm.selected_note = item;
        vm.selected_note.title = vm.selected_note.title || "Untitled";
        vm.isManipulatingNotes = false;
      }
    },
    selectEmail(item) {
      let vm = this;
      vm.selected_note = null;
      vm.selected_task = null;
      vm.selected_lead = null;
      vm.selected_calendar = null;
      vm.selected_email = item;
    },
    selectTask(item) {
      let vm = this;
      vm.selected_note = null;
      vm.selected_email = null;
      vm.selected_task = item;
      vm.selected_lead = null;
      vm.selected_calendar = null;
    },
    selectLead(item) {
      let vm = this;
      vm.selected_note = null;
      vm.selected_email = null;
      vm.selected_task = null;
      vm.selected_lead = item;
      vm.selected_calendar = null;
    },
    selectCalendar(item) {
      let vm = this;
      vm.selected_note = null;
      vm.selected_email = null;
      vm.selected_task = null;
      vm.selected_lead = null;
      vm.selected_calendar = item;
      vm.isManipulatingNotes = false;
    },
    getCalendarEventTitle(item) {
      if (!item || !item.action) {
        return 'Calendar Event';
      }

      try {
        const eventData = JSON.parse(item.action);
        return eventData.summary || 'Untitled Event';
      } catch (error) {
        console.error('Error parsing calendar event data:', error);
        return 'Calendar Event';
      }
    },
    addNewNote() {
      let vm = this;
      vm.isManipulatingNotes = true;
      vm.selected_email = null;
      vm.selected_note = null;
      vm.selected_task = null;
      vm.selected_lead = null;
      vm.selected_calendar = null;
    },
    onCloseAddNoteWidget() {
      let vm = this;
      vm.isManipulatingNotes = false;
      vm.selected_note = null;
    },
    getAllNotes() {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("NOTES_GET_ALL", vm.form_filter)
        .then((responce) => {
          vm.isLoading = false;
          vm.notes_data = responce.data.map((item) => {
            if (item.created_by) {
              eventBus.$set(item, "owner", item.created_by);
            } else {
              eventBus.$set(item, "owner", null);
            }
            eventBus.$set(item, "checked", false);
            return item;
          });


        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    onDeleteNote(item) {
      let vm = this;
      vm.$store
        .dispatch("NOTES_DELETE", {
          id: item.id,
        })
        .then((responce) => {
          vm.addNewNote();
          vm.getAllNotes();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Note is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    // ===============================
    deletedSelectedNote() {
      let vm = this;
      vm.$store
        .dispatch("NOTES_DELETE_SELECTED", {
          ids: vm.validateCheckedNote("data"),
        })
        .then((responce) => {
          vm.getAllNotes();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Note is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    validateCheckedNote(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_activities_options =
          vm.notes_data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.notes_data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllNote({ target }) {
      let vm = this;
      if (target.checked) {
        vm.notes_data = vm.notes_data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.notes_data = vm.notes_data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedNote();
    },
    checkNote(item) {
      let vm = this;
      item.checked = !item.checked;
      vm.validateCheckedNote("validate");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .notes-filter {
    width: 100%;
    height: 40px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }

  .page-body {
    height: calc(100% - 83px);
    display: flex;

    .notes-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;

      .notes-widget {
        width: 100%;
        height: 100%;
        position: relative;

        .custom-resizer {
          height: 100%;
        }

        .notes-list {
          display: flex;
          flex-direction: column;
          height: 100%;
          min-width: calc(100% - 550px);
          width: 100%;
          position: relative;
          background: #fff;
          border-radius: 5px;
          padding: 10px;

          .notes-body {
            height: 100%;
            overflow-y: auto;
            padding-bottom: 0px;

            .notes-item {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              align-items: center;
              padding: 5px;
              border: 1px solid rgba(91, 91, 91, 0.05);
              cursor: pointer;
              border-radius: 5px;
              margin-bottom: 5px;

              &.system-activity {
                background: #f0f0f0;
                display: flex !important;
                justify-content: space-between;
                padding: 0px 5px;

                .note-content {
                  font-size: 10px !important;
                }

                .note-time {
                  font-size: 10px !important;
                }
              }

              &.task-activity {
                background: #f4f4f4;
                display: flex !important;
                justify-content: space-between;
                padding: 2px 5px;
                border: 1px solid #e0e0e0;

                .note-content {
                  font-size: 10px !important;
                  color: #000;
                }

                .note-time {
                  font-size: 10px !important;
                  color: #000;
                }
              }

              &.lead-activity {
                background: #f4f4f4;
                display: flex !important;
                justify-content: space-between;
                padding: 2px 5px;
                border: 1px solid #e0e0e0;

                .note-content {
                  font-size: 10px !important;
                  color: #000;
                }

                .note-time {
                  font-size: 10px !important;
                  color: #000;
                }
              }

              &.email-activity {
                background: #f4f4f4;
                display: flex !important;
                justify-content: space-between;
                padding: 2px 5px;
                border: 1px solid #e0e0e0;

                .note-content {
                  font-size: 10px !important;
                  color: #000;
                }

                .note-time {
                  font-size: 10px !important;
                  color: #000;
                }
              }

              &.calendar-activity {
                background: #f4f4f4;
                display: flex !important;
                justify-content: space-between;
                padding: 2px 5px;
                border: 1px solid #e0e0e0;

                .note-content {
                  font-size: 10px !important;
                  color: #000;
                }

                .note-time {
                  font-size: 10px !important;
                  color: #000;
                }
              }

              .notes-item-col {
                display: flex;
                align-items: center;

                .note-content {
                  font-size: 12px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 200px;
                }

                .note-contact {
                  background-color: rgba(8, 132, 175, 0.14);
                  padding: 3px;
                  border-radius: 11px;
                }
              }
            }


          }
        }

        .note-details {
          width: 500px;
          min-width: 540px;
          max-width: 550px;
          display: flex;
          flex-direction: column;
          height: 100%;
          background: #fff;
          border-radius: 5px;



          .empty-widget {
            display: flex;
            align-content: center;
            justify-content: center;
            padding-top: 40px;
          }
        }
      }

      .notes-not-found-widget {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 5px;
      }

      .form-widget-modal {
        width: 500px;
        min-height: 200px;
        padding: 20px;

        .moder-header {}

        .modal-body {
          .input-group {
            position: relative;

            .exist-company {
              width: 100%;

              .input-form {
                width: 100%;
              }

              .selected-company {
                border: 1px solid #ddd;
                background: #fff;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0px 10px;

                .content {
                  display: flex;
                  align-items: center;

                  img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                  }
                }

                .option {
                  .btn-close {
                    font-size: 20px;
                    background: #7f0404;
                    color: #fff;
                    border-radius: 5px;
                  }
                }
              }

              .search-result-widget {
                position: absolute;
                top: 75px;
                height: 200px;
                width: 100%;
                background: #fff;
                z-index: 999;
                box-shadow: 0px 0px 3px #ccc;
                border-radius: 5px;
                overflow-y: auto;

                .search-item {
                  display: flex;
                  align-items: center;
                  padding: 4px 10px;
                  border-bottom: 1px solid #ddd;
                  cursor: pointer;

                  &:hover {
                    background: rgb(240, 240, 240);
                  }

                  img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                    border-radius: 50%;
                    margin-right: 15px;
                  }
                }
              }
            }

            .new-company-field {
              width: 100%;

              .input-form {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>

<style lang="scss">
.notes-editor-widget {
  .ql-container.ql-snow {
    border: 1px solid #fff;
    height: 400px;
  }
}
</style>
